import { makeSx } from '../../../../theme/_utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    wrapper: {
        width: '100%',
    },
    label: {
        fontWeight: 600,
        color: defaultPalette.typography.mediumDark,
    },
    container: {
        width: '100%',
        border: `2px solid ${defaultPalette.primary.main}`,
        borderRadius: '0.625rem',
        overflow: 'hidden',
    },
    button: {
        width: '100%',
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: '5%',
        border: 'none !important',
    },
    buttonLabel: {
        margin: '0px',
        justifyContent: 'center',
        fontSize: {
            xs: '0.75rem',
            md: '1rem',
        },
    },
})
